/*
    * Set v-model="isOpen" on <base-modal/> if:
    * <base-modal/> is a child component and its parent controls hide/show visibility
    *
    * <parent-component v-model="hideShowModel">
    *   <base-modal v-model="isOpen"/>>
    * </parent-component>
    *
    * Import mixin in the component that declares <base-modal>. ie the parent component.
    * Set this.isOpen to true or false inside this component.
    * The setter will then notify the parent v-model value that the modal isOpen has changed.
    */

export default {
  model: {
    prop: 'open',
    event: 'show',
  },
  props: {
    open: {
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      hidden: false,
    };
  },
  computed: {
    isOpen: {
      get() {
        return this.open !== undefined
          ? this.open
          : this.hidden;
      },
      set(val) {
        /*
        * Once v-model (isOpen) is set to true or false we must update the parent v-model ('show' emitter) as we cannot mutate a parent prop directly.
        * We maintain local (this.hidden) and parent (v-model) state so they remain in sync.
        */
        this.hidden = val;
        this.$emit('show', val);
      },

    },
  },
};
